import classnames from "classnames";

import styles from "./Checkbox.module.scss";

const Checkbox = ({ id, label, value, onChange, className, error }) => {
  return (
    <div className={classnames(styles.group, className, { [styles.error]: error })}>
      <input
        className={styles.input}
        type="checkbox"
        id={id}
        checked={value}
        onChange={onChange}
      />
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
